export function trialAtivo(user) {
  if (!user?.data_fim_trial) return false;
  return new Date(user.data_fim_trial) > new Date();
}

export function temModuloFinanceiro(user) {
  if (!user) return false;
  if (typeof user.tem_modulo_financeiro === 'boolean') {
    return user.tem_modulo_financeiro;
  }
  if (user.acesso_vitalicio) return true;
  if (trialAtivo(user) && !user.plano_financeiro_ativo && !user.plano_milhas_ativo) {
    return true;
  }
  return Boolean(user.plano_financeiro_ativo);
}

export function temModuloMilhas(user) {
  if (!user) return false;
  if (typeof user.tem_modulo_milhas === 'boolean') {
    return user.tem_modulo_milhas;
  }
  if (user.acesso_vitalicio) return true;
  if (trialAtivo(user) && !user.plano_financeiro_ativo && !user.plano_milhas_ativo) {
    return true;
  }
  return Boolean(user.plano_milhas_ativo);
}

export function temAlgumModulo(user) {
  return temModuloFinanceiro(user) || temModuloMilhas(user);
}

/** Ferramentas de prestador (Clientes + A receber). Cobrança WhatsApp não depende deste flag. */
export function temModoPrestador(user) {
  if (!user) return false;
  return Boolean(user.modo_prestador_ativo) && temModuloFinanceiro(user);
}
